import type { ColDef } from '@ag-grid-community/core';

import IRPContactsCountCell from './IRPContactsCountCell.vue';
import IRPDataSourceCell from './IRPDataSourceCell.vue';
import IRPOpenOpportunitiesCell from './IRPOpenOpportunitiesCell.vue';
import IRPOwnerCell from './IRPOwnerCell.vue';
import IRPPartnerCell from './IRPPartnerCell.vue';
import IRPPartnerScoreCell from './IRPPartnerScoreCell.vue';
import IRPPopulationsCell from './IRPPopulationsCell.vue';

export function useRecommendedPartnersColumnDefinitions(): ColDef[] {
  return [
    {
      field: 'partner_name',
      headerName: 'Partner',
      cellRenderer: IRPPartnerCell,
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'partner_score_bucket',
      headerName: 'Partner Score',
      cellRenderer: IRPPartnerScoreCell,
      width: 140,
    },
    {
      field: 'account_owners',
      headerName: 'Partner Account Owner',
      cellRenderer: IRPOwnerCell,
      minWidth: 180,
    },
    {
      field: 'contacts',
      headerName: 'Contacts',
      cellRenderer: IRPContactsCountCell,
      width: 180,
    },
    {
      field: 'opportunities',
      headerName: 'Open Opportunities',
      cellRenderer: IRPOpenOpportunitiesCell,
      width: 160,
    },
    {
      field: 'partner_population_ids',
      headerName: 'Populations',
      cellRenderer: IRPPopulationsCell,
      minWidth: 180,
    },
    {
      field: 'data_sources',
      headerName: 'Data Source',
      cellRenderer: IRPDataSourceCell,
      width: 160,
    },
  ];
}
